// extracted by mini-css-extract-plugin
export default {"container":"container__3O2JO","title":"title__vYFQ9","text":"text__2CzXA","svg":"svg__14ELx"};